class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();
      const cartItems =
        this.closest("cart-items") || this.closest("cart-drawer-items");
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemStatusElement =
      document.getElementById("shopping-cart-line-item-status") ||
      document.getElementById("CartDrawer-LineItemStatus");

    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);

    this.addEventListener("change", debouncedOnChange.bind(this));
  }

  runScripts(container) {
    if (!container) return;
    const scripts = Array.from(container.querySelectorAll("script"));
    scripts.forEach((old) => {
      const s = document.createElement("script");
      for (const attr of old.attributes) s.setAttribute(attr.name, attr.value);
      if (old.textContent) s.textContent = old.textContent;
      old.parentNode.replaceChild(s, old);
    });
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      (event) => {
        if (event.source === "cart-items") {
          return;
        }
        this.onCartUpdate();
      },
    );
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  resetQuantityInput(id) {
    const input = this.querySelector(`#Quantity-${id}`);
    input.value = input.getAttribute("value");
    this.isEnterPressed = false;
  }

  setValidity(event, index, message) {
    event.target.setCustomValidity(message);
    event.target.reportValidity();
    this.resetQuantityInput(index);
    event.target.select();
  }

  validateQuantity(event) {
    const inputValue = parseInt(event.target.value);
    const index = event.target.dataset.index;
    let message = "";

    if (inputValue < event.target.dataset.min) {
      message = window.quickOrderListStrings.min_error.replace(
        "[min]",
        event.target.dataset.min,
      );
    } else if (inputValue > parseInt(event.target.max)) {
      message = window.quickOrderListStrings.max_error.replace(
        "[max]",
        event.target.max,
      );
    } else if (inputValue % parseInt(event.target.step) !== 0) {
      message = window.quickOrderListStrings.step_error.replace(
        "[step]",
        event.target.step,
      );
    }

    if (message) {
      this.setValidity(event, index, message);
    } else {
      event.target.setCustomValidity("");
      event.target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        document.activeElement.getAttribute("name"),
        event.target.dataset.quantityVariantId,
      );
    }
  }

  onChange(event) {
    this.validateQuantity(event);
  }

  onCartUpdate() {
    if (this.tagName === "CART-DRAWER-ITEMS") {
      return;
      // Request the instantiated section id when available so server returns the
      // actual section instance (including app blocks). Fall back to the handle.
      const drawerHandles = ["cart-drawer"];
      const drawerSectionEl = this.closest(".shopify-section");
      if (drawerSectionEl) {
        if (drawerSectionEl.dataset && drawerSectionEl.dataset.sectionId)
          drawerHandles[0] = drawerSectionEl.dataset.sectionId;
        else if (
          drawerSectionEl.id &&
          drawerSectionEl.id.startsWith("shopify-section-")
        )
          drawerHandles[0] = drawerSectionEl.id.replace("shopify-section-", "");
      }

      const drawerUrl = `${routes.cart_url}?sections=${drawerHandles.join(",")}`;
      console.debug("cart.onCartUpdate: drawer refresh URL", drawerUrl);

      window
        .fetch(drawerUrl)
        .then((response) => response.text())
        .then((responseText) => {
          // Handle sections JSON or full HTML responses
          let parsedDoc;
          let usedJson = false;
          try {
            const sectionsMap = JSON.parse(responseText);
            const key = drawerHandles[0];
            const sectionHtml =
              sectionsMap[key] || sectionsMap["cart-drawer"] || null;
            if (sectionHtml) {
              parsedDoc = new DOMParser().parseFromString(
                sectionHtml,
                "text/html",
              );
              usedJson = true;
              console.debug("cart.onCartUpdate: parsed sections JSON for", key);
            }
          } catch (_) {
            // not JSON, fall through to HTML parsing
          }

          if (!parsedDoc) {
            parsedDoc = new DOMParser().parseFromString(
              responseText,
              "text/html",
            );
            console.debug("cart.onCartUpdate: parsed HTML response");
          }

          // Replace only the items and the footer
          // Use imported nodes to preserve proper adoption into current document
          const pairs = [
            { selector: "cart-drawer-items" },
            { selector: "#CartDrawer .cart-reward-progress-wrapper" },
            { selector: ".drawer__footer" },
            { selector: ".cart-drawer__footer" },
          ];
          for (const { selector } of pairs) {
            const target = document.querySelector(selector);
            const source = parsedDoc.querySelector(selector);
            if (target && source) {
              const imported = document.importNode(source, true);
              target.replaceWith(imported);
              console.debug(
                "cart.onCartUpdate: replaced",
                selector,
                usedJson ? "(JSON)" : "(HTML)",
              );
            }
          }

          // Populate/refresh CTAs from the parsed response if available
          const serverCtas =
            parsedDoc.querySelector("#CartDrawer .cart__ctas") ||
            parsedDoc.querySelector(".cart__ctas");
          const drawerCtas = document.querySelector("#CartDrawer .cart__ctas");
          if (serverCtas && drawerCtas) {
            console.debug(
              "cart.onCartUpdate: applying server CTAs into drawer (",
              usedJson ? "JSON" : "HTML",
              ")",
            );
            drawerCtas.innerHTML = serverCtas.innerHTML;
            this.runScripts(drawerCtas);
            document.querySelector("cart-drawer")?.dispatchEvent(
              new CustomEvent("shopify:section:load", {
                detail: { sectionId: "cart-drawer" },
              }),
            );
          } else {
            // If CTAs exist, just allow any app observers to re-run
            const updatedCtas =
              document.querySelector("#CartDrawer .cart__ctas") ||
              document.querySelector(".cart__ctas");
            if (updatedCtas) {
              console.debug(
                "cart.onCartUpdate: no server CTAs found; re-running existing CTAs scripts",
              );
              this.runScripts(updatedCtas);
            } else {
              console.debug(
                "cart.onCartUpdate: drawer CTAs container not found in DOM",
              );
            }
          }

          document.dispatchEvent(new CustomEvent("cart:drawer:updated"));
        })
        .catch((e) => {
          console.error(e);
        });
    } else {
      // Prefer the instantiated section id for main cart items if present on the page
      const mainHandles = ["main-cart-items"];
      const mainSectionEl = document.getElementById("main-cart-items");
      if (mainSectionEl && mainSectionEl.dataset && mainSectionEl.dataset.id) {
        mainHandles[0] = mainSectionEl.dataset.id;
      }

      const mainUrl = `${routes.cart_url}?sections=${mainHandles.join(",")}`;

      window
        .fetch(mainUrl)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html",
          );
          const sourceQty = html.querySelector("cart-items");
          if (sourceQty) this.innerHTML = sourceQty.innerHTML;
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }

  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".js-contents",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer").dataset.id,
        selector: ".js-contents",
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    // Coalesce rapid clicks on the same line instead of dropping them: while
    // a request for this line is in flight, remember only the latest
    // desired quantity and fire it as soon as the in-flight one resolves,
    // rather than letting the pointer-events lock swallow the click outright.
    this._inFlightLines = this._inFlightLines || new Set();
    this._pendingLineUpdates = this._pendingLineUpdates || new Map();

    if (this._inFlightLines.has(line)) {
      this._pendingLineUpdates.set(line, { quantity, name, variantId });
      return;
    }

    this._inFlightLines.add(line);
    this._performQuantityUpdate(line, quantity, name, variantId);
  }

  _performQuantityUpdate(line, quantity, name, variantId) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    window
      .fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) ||
          document.getElementById(`Drawer-quantity-${line}`);
        const items = document.querySelectorAll(".cart-item");
        const hasServerCartState = Boolean(
          parsedState.sections && parsedState.items,
        );

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute("value");
          if (!hasServerCartState) {
            this.updateLiveRegions(line, parsedState.errors);
            return;
          }
        }

        /*this.classList.toggle("is-empty", parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector("cart-drawer");
        const cartFooter = document.getElementById("main-cart-footer");

        if (cartFooter)
          cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
        if (cartDrawerWrapper)
          cartDrawerWrapper.classList.toggle(
            "is-empty",
            parsedState.item_count === 0,
          );

        // Preserve CTAs HTML in the cart drawer before sections replacement (so app blocks persist)
        const existingDrawerCtas = document.querySelector(
          "#CartDrawer .cart__ctas",
        );
        const preservedDrawerCtasHtml = existingDrawerCtas
          ? existingDrawerCtas.innerHTML
          : null;

        this.getSectionsToRender().forEach((section) => {
          const elementToReplace =
            document
              .getElementById(section.id)
              .querySelector(section.selector) ||
            document.getElementById(section.id);
          elementToReplace.innerHTML = this.getSectionInnerHTML(
            parsedState.sections[section.section],
            section.selector,
          );
        });*/

        // Restore CTAs (with app blocks) after the drawer markup has been replaced
        /*try {
          const newDrawerCtas = document.querySelector(
            "#CartDrawer .cart__ctas",
          );
          if (newDrawerCtas) {
            if (preservedDrawerCtasHtml) {
              console.debug(
                "cart.updateQuantity: restoring preserved drawer CTAs",
              );
              newDrawerCtas.innerHTML = preservedDrawerCtasHtml;
              this.runScripts(newDrawerCtas);
              document.querySelector("cart-drawer")?.dispatchEvent(
                new CustomEvent("shopify:section:load", {
                  detail: { sectionId: "cart-drawer" },
                }),
              );
            } else {
              // Fallback: inject from hidden server-rendered copy if available
              const pageAppBlocks = document.getElementById(
                "CartDrawer-AppBlocks",
              );
              if (pageAppBlocks) {
                console.debug(
                  "cart.updateQuantity: restoring CTAs from hidden page copy (CartDrawer-AppBlocks)",
                );
                newDrawerCtas.innerHTML = pageAppBlocks.innerHTML;
                this.runScripts(newDrawerCtas);
                document.querySelector("cart-drawer")?.dispatchEvent(
                  new CustomEvent("shopify:section:load", {
                    detail: { sectionId: "cart-drawer" },
                  }),
                );
              }
            }
          }
        } catch (e) {
          console.warn("Failed to restore cart drawer CTAs after update", e);
        }
        const updatedValue = parsedState.items[line - 1]
          ? parsedState.items[line - 1].quantity
          : undefined;
        let message = "";
        if (parsedState.errors && hasServerCartState) {
          message = Array.isArray(parsedState.errors)
            ? parsedState.errors.join(", ")
            : parsedState.errors;
        } else if (
          items.length === parsedState.items.length &&
          updatedValue !== parseInt(quantityElement.value)
        ) {
          if (typeof updatedValue === "undefined") {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace(
              "[quantity]",
              updatedValue,
            );
          }
        }
        this.updateLiveRegions(line, message);

        const lineItem =
          document.getElementById(`CartItem-${line}`) ||
          document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(
                cartDrawerWrapper,
                lineItem.querySelector(`[name="${name}"]`),
              )
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper.querySelector(".drawer__inner-empty"),
            cartDrawerWrapper.querySelector("a"),
          );
        } else if (document.querySelector(".cart-item") && cartDrawerWrapper) {
          trapFocus(
            cartDrawerWrapper,
            document.querySelector(".cart-item__name"),
          );
        }*/

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "cart-items",
          cartData: parsedState,
          variantId: variantId,
        });

        document.dispatchEvent(
          new CustomEvent("cart:updated", {
            detail: { cart: parsedState },
          }),
        );
      })
      .catch(() => {
        this.querySelectorAll(".loading__spinner").forEach((overlay) =>
          overlay.classList.add("hidden"),
        );
        const errors =
          document.getElementById("cart-errors") ||
          document.getElementById("CartDrawer-CartErrors");
        errors.textContent = window.cartStrings.error;
      })
      .finally(() => {
        this.disableLoading(line);
        this._inFlightLines.delete(line);
        const next = this._pendingLineUpdates.get(line);
        if (next) {
          this._pendingLineUpdates.delete(line);
          this._inFlightLines.add(line);
          this._performQuantityUpdate(
            line,
            next.quantity,
            next.name,
            next.variantId,
          );
        }
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError =
      document.getElementById(`Line-item-error-${line}`) ||
      document.getElementById(`CartDrawer-LineItemError-${line}`);
    if (lineItemError)
      lineItemError.querySelector(".cart-item__error-text").textContent =
        message;

    this.lineItemStatusElement.setAttribute("aria-hidden", true);

    const cartStatus =
      document.getElementById("cart-live-region-text") ||
      document.getElementById("CartDrawer-LiveRegionText");
    cartStatus.setAttribute("aria-hidden", false);

    setTimeout(() => {
      cartStatus.setAttribute("aria-hidden", true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.add("cart__items--disabled");

    // Keep the row the shopper is actively adjusting clickable even while
    // the container-wide lock is on, so repeated clicks on that same row's
    // quantity buttons keep registering (and get coalesced in
    // updateQuantity) instead of being silently swallowed by pointer-events.
    const activeRow = document.getElementById(`CartItem-${line}`);
    const activeDrawerRow = document.getElementById(`CartDrawer-Item-${line}`);
    if (activeRow) activeRow.classList.add("cart-item--active-update");
    if (activeDrawerRow)
      activeDrawerRow.classList.add("cart-item--active-update");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading__spinner`,
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading__spinner`,
    );

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
      overlay.classList.remove("hidden"),
    );

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }

  disableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.remove("cart__items--disabled");

    const activeRow = document.getElementById(`CartItem-${line}`);
    const activeDrawerRow = document.getElementById(`CartDrawer-Item-${line}`);
    if (activeRow) activeRow.classList.remove("cart-item--active-update");
    if (activeDrawerRow)
      activeDrawerRow.classList.remove("cart-item--active-update");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading__spinner`,
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading__spinner`,
    );

    cartItemElements.forEach((overlay) => overlay.classList.add("hidden"));
    cartDrawerItemElements.forEach((overlay) =>
      overlay.classList.add("hidden"),
    );
  }

  updateAttributes(html) {
    this.updateInputsFromStorage(
      html,
      'input[id="__cartDrawerLoyaltyStatus"]',
      "_tcloyalty",
    );
    this.updateInputsFromStorage(
      html,
      'input[id="__cartDrawerDiscountCode"]',
      "_tcdiscount",
    );
  }

  updateInputsFromStorage(html, selector, key) {
    var inputs = html.querySelectorAll(selector);
    inputs.forEach(function (input) {
      input.value = localStorage.getItem(key) || "";
    });
  }
}

customElements.define("cart-items", CartItems);

if (!customElements.get("cart-note")) {
  customElements.define(
    "cart-note",
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          "input",
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            window.fetch(`${routes.cart_update_url}`, {
              ...fetchConfig(),
              ...{ body },
            });
          }, ON_CHANGE_DEBOUNCE_TIMER),
        );
      }
    },
  );
}

function ShowFlyerMessage() {
  let ShowFlyerMessage = new URLSearchParams(window.location.search).get(
    "show_flyer_message",
  );

  let flyerCode = new URLSearchParams(window.location.search).get(
    "utm_campaign",
  );

  if (!ShowFlyerMessage || ShowFlyerMessage !== "true" || !flyerCode) return;

  const flyerCodeMessage = document.querySelector("#flyoverMessage");
  if (flyerCodeMessage) {
    flyerCodeMessage.innerHTML = flyerCodeMessage.innerHTML.replace(
      "Code",
      flyerCode,
    );
    flyerCodeMessage.classList.remove("visually-hidden");
    document.querySelector("#flyerCodeForm").classList.add("visually-hidden");
    document
      .querySelector("#flyerCodeFormDrawer")
      .classList.add("visually-hidden");
  }
}

ShowFlyerMessage();
